import { render, staticRenderFns } from "./ModalGift.vue?vue&type=template&id=4c15a256"
import script from "./ModalGift.vue?vue&type=script&lang=js"
export * from "./ModalGift.vue?vue&type=script&lang=js"
import style0 from "./ModalGift.vue?vue&type=style&index=0&id=4c15a256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports